const AUTH_STORAGE_KEY = '@User:Betbuilder'
const ADMIN_ACCESS_MODE_KEY = '@AdminAccessMode:Betbuilder'

const isObject = (value) => value && typeof value === 'object' && !Array.isArray(value)

const parseRawAuthStorage = (rawValue) => {
    if (!rawValue) {
        return null
    }

    try {
        let parsed = JSON.parse(rawValue)

        if (typeof parsed === 'string') {
            parsed = JSON.parse(parsed)
        }

        if (Array.isArray(parsed)) {
            const first = parsed[0]
            if (typeof first === 'string') {
                return JSON.parse(first)
            }
            return first
        }

        return parsed
    } catch (err) {
        return null
    }
}

const parseBoolean = (value) => {
    if (typeof value === 'boolean') {
        return value
    }

    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase()
        if (normalized === 'true') {
            return true
        }

        if (normalized === 'false') {
            return false
        }
    }

    return false
}

export const normalizeAuthStorage = (input, tokenOverride) => {
    const source = isObject(input) ? input : {}

    const accessToken = (
        tokenOverride ||
        source?.accessToken ||
        source?.token ||
        source?.data?.accessToken ||
        source?.data?.token ||
        source?.user?.accessToken ||
        source?.authToken ||
        ''
    )

    const normalizedToken = accessToken
        ? String(accessToken).replace(/^Bearer\s+/i, '').replace(/^"|"$/g, '').trim()
        : ''

    let user = null

    if (isObject(source?.user)) {
        user = source.user
    } else if (isObject(source?.data) && (source.data.id || source.data._id || source.data.email || source.data.username || source.data.name)) {
        user = source.data
    } else if (source?.id || source?._id || source?.email || source?.username || source?.name) {
        user = source
    }

    return {
        accessToken: normalizedToken,
        user: user
            ? {
                id: user.id || user._id || '',
                name: user.name || user.nome || '',
                email: user.email || '',
                username: user.username || '',
                isAdmin: parseBoolean(
                    user.isAdmin ??
                    source?.isAdmin ??
                    source?.data?.isAdmin ??
                    source?.user?.isAdmin
                )
            }
            : null,
        expiresIn: source?.expiresIn,
        refreshToken: source?.refreshToken,
        tokenType: source?.tokenType || ''
    }
}

export const getStoredAuthData = () => {
    const parsed = parseRawAuthStorage(localStorage.getItem(AUTH_STORAGE_KEY))
    return normalizeAuthStorage(parsed)
}

export const setStoredAuthData = (input, tokenOverride) => {
    const normalized = normalizeAuthStorage(input, tokenOverride)
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(normalized))
    return normalized
}

export const mergeStoredUserProfile = (profile) => {
    const current = getStoredAuthData()
    const normalizedProfile = normalizeAuthStorage(profile)

    const merged = {
        ...current,
        user: {
            ...(current.user || {}),
            ...(normalizedProfile.user || {})
        }
    }

    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(merged))
    return merged
}

export const getStoredAccessToken = () => getStoredAuthData().accessToken || ''

export const getStoredUser = () => getStoredAuthData().user || null

export const getStoredUserId = () => {
    const user = getStoredUser()
    return user?.id || ''
}

export const clearStoredAuthData = () => {
    localStorage.removeItem(AUTH_STORAGE_KEY)
}

export const getStoredAdminAccessMode = () => {
    const mode = localStorage.getItem(ADMIN_ACCESS_MODE_KEY)
    if (mode === 'site' || mode === 'panel') {
        return mode
    }

    return null
}

export const setStoredAdminAccessMode = (mode) => {
    if (mode === 'site' || mode === 'panel') {
        localStorage.setItem(ADMIN_ACCESS_MODE_KEY, mode)
        return mode
    }

    localStorage.removeItem(ADMIN_ACCESS_MODE_KEY)
    return null
}

export const clearStoredAdminAccessMode = () => {
    localStorage.removeItem(ADMIN_ACCESS_MODE_KEY)
}
